import { useQuery } from "@tanstack/react-query";
import { Mission, StreakedMission } from "../types/Mission";
import { BackendAPI } from "../util/Env";
import { useMsal } from "@azure/msal-react";
import { useCompletionsQuery } from "./completion-queries";
import { calcStreakLength } from "../util/Streak";
import { fullDaysBetween } from "../util/Time";

export const missionsKey = 'missions';

export const useMissions = () => {

    const { completions } = useCompletionsQuery()

    const { accounts } = useMsal();
    const { data } = useQuery({
        queryKey: [missionsKey],
        queryFn: async () => {
            const response = await fetch(`${BackendAPI}/missions-api.php`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'ownerId': accounts[0].idTokenClaims!.oid!,
                },
            });

            if (!response.ok) {
                throw new Error(`Error fetching missions: ${response.statusText}`);
            }

            return (await response.json()) as Mission[];

        }
    });


    if (data) {
        data.forEach((mission: StreakedMission) => {
            if ((mission as any).streak_expiration !== null) {
                mission.streakExpiration = (mission as any).streak_expiration;
            }

            const missionCompletions = completions?.filter((completion) => completion.missionId === mission.id);
            if (mission.streakExpiration && missionCompletions) {
                const lastCompletion = missionCompletions.sort((a, b) => b.date.getTime() - a.date.getTime())[0];
                if (!lastCompletion) {
                    return;
                }
                const remainingDays = mission.streakExpiration - fullDaysBetween(lastCompletion.date, new Date());
                mission.streak = calcStreakLength(mission.streakExpiration)(missionCompletions.map((completion) => completion.date));
                mission.daysLeft = remainingDays;
            }
        });
    }

    return {
        repeatingMissions: data?.filter((mission: Mission) => mission.repeatable) as StreakedMission[] || [],
        oneshotMissions: data?.filter((mission: Mission) => !mission.repeatable) || []
    };
}

export const useMission = (id: string | undefined) => {
    const { repeatingMissions, oneshotMissions } = useMissions();

    return { mission: [...repeatingMissions, ...oneshotMissions].find(mission => mission.id === id) };
}